"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ToggleInput = function ToggleInput(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      falseLabel = _ref.falseLabel,
      trueLabel = _ref.trueLabel,
      otherProps = _objectWithoutProperties(_ref, ["className", "checked", "disabled", "onChange", "falseLabel", "trueLabel"]);

  var _useState = (0, _react.useState)(checked ? true : false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  (0, _react.useEffect)(function () {
    setIsActive(checked);
  }, [checked]);

  var handleChange = function handleChange(e) {
    e.persist();
    setIsActive(e.currentTarget.checked);
    onChange({
      name: e.target.name,
      checked: e.target.checked
    });
  };

  return /*#__PURE__*/_react.default.createElement(ToggleWrapper, _extends({
    disabled: disabled,
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement("label", null, falseLabel), /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    disabled: disabled,
    onChange: function onChange(e) {
      return handleChange(e);
    },
    checked: isActive
  }), /*#__PURE__*/_react.default.createElement("label", null, trueLabel));
};

var ToggleWrapper = _styledComponents.default.div.withConfig({
  displayName: "ToggleWrapper"
})(["align-self:stretch;padding:1.6rem 0;text-align:center;opacity:", ";display:flex;justify-content:flex-start;align-items:center;label{font-family:", ";font-size:1.4rem;font-weight:400;color:black;}input[type='checkbox']{position:relative;appearance:none;width:50px;height:26px;background-color:#e4e4e4;border-radius:calc(5rem / 2);outline:none;transition:background-color 0.4s cubic-bezier(0.83,0,0.17,1);cursor:pointer;margin-left:16px;margin-right:16px;&::before{position:absolute;display:block;content:'';border-radius:9999px;left:2px;top:2px;width:21px;height:21px;background-color:white;transition:background 0.4s cubic-bezier(0.83,0,0.17,1),left 0.4s cubic-bezier(0.83,0,0.17,1);box-shadow:0 0 10px rgba(32,32,35,0.1);}&:checked{background-color:", ";&::before{left:calc(100% - 24px);}}&:disabled{cursor:not-allowed;}}"], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? '0.65' : '1';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.brand.primary;
});

ToggleInput.propTypes = {
  className: _propTypes.string,
  checked: _propTypes.bool,
  disabled: _propTypes.bool,
  onChange: _propTypes.func.isRequired,
  falseLabel: _propTypes.string,
  trueLabel: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = ToggleInput;
exports.default = _default;